import { useState } from 'react';
import { roles, routes } from '../../constants';
import { ClickOutside } from '../common/ClickOutside';
import { NavBarSubItem } from './NavBarSubItem';
import { useHistory } from 'react-router-dom';
import { ShowFor } from '../access';

export const ProfilesMenuItem = () => {
    const history = useHistory();
    const [expanded, setExpanded] = useState(false);

    const toggleExpanded = () => setExpanded(!expanded)

    const pathnameStartsWth = (path: string) => history.location.pathname.includes(path)

    const isActive = () => {
        const isActive = 
            pathnameStartsWth(routes.manageBanks) || 
            pathnameStartsWth(routes.manageCloManagers)

        return isActive ? 'active' : '';
    }

    return (
        <ShowFor
            roles={[...roles.bd(), ...roles.seller(), roles.Media, roles.CollateralManager]}
        >
            <li className={`navbar-item dropdown ${expanded ? 'show' : ''}`}>
                <button
                    type="button"
                    className={`btn-link navbar-link dropdown-toggle ${isActive()}`}
                    onClick={toggleExpanded}
                >
                    Profiles
                </button>
                <div className={`dropdown-menu navbar-dropdown-menu navbar-dropdown-manage ${expanded ? 'show' : ''}`}>
                    {expanded && (
                        <ClickOutside onClick={() => setExpanded(false)}>
                            <>
                                <ShowFor
                                    roles={[...roles.bd(), ...roles.seller(), roles.Media]}>
                                    <NavBarSubItem
                                        title="Banks"
                                        path={routes.manageBanks}
                                        onClick={() => setExpanded(false)}
                                    />
                                </ShowFor>
                                <ShowFor roles={[roles.CollateralManager, roles.Media, ...roles.bd(), ...roles.seller()]}>
                                    <NavBarSubItem
                                        title="CLO Managers"
                                        path={routes.manageCloManagers}
                                        onClick={() => setExpanded(false)}
                                    />
                                </ShowFor>
                            </>
                        </ClickOutside>
                    )}
                </div>
            </li>
        </ShowFor>
    )
};
